import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';

export const templateComplianceApp = document.createElement('template');

templateComplianceApp.innerHTML = `
  <style>
    ${widgetSharedStyles}
  </style>
  <style>
    ${colorHelpersStyles}
  </style>
  <style>
    ${flexboxHelpersStyles}
  </style>
  <style>
    ${styleHelpers}
  </style>
  <style>
    ${textHelpersStyles}
  </style>
  <style>
    ${commonStyles}
  </style>
  <style>
    ${styles}
  </style>

  <gz-push-body-layout resizable="right">
    <div slot="push-body-sidenav">
      <gz-generic-grid-smart-views class="hidden" id="smart-views" hasSearchInput="true"></gz-generic-grid-smart-views>
      <div class="loader">
        <gz-loader rows="4" class="smartview-loader"></gz-loader>
        <gz-loader rows="4" class="smartview-loader"></gz-loader>
      </div>
    </div>
    <div slot="push-body-sidenav-title">
      <gz-title id="smartViewsTitle" fontweight="600" fontsize="11"></gz-title>
    </div>

    <div class="risk-management push-body" slot="push-body-content">
      <div class="push-body--menu"></div>
      <div class="push-body--content">
        <div class="wrapper">
          <div class="compliance-header">
            <div class="compliance-header--top">
              <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
            </div>
          </div>
          <div class="risk-management-content">
            <div class="risk-management-grid">
              <gz-grid-view showInfoBox showGlobalActions>
                <div id="compliance-info-box" class="hidden" slot="grid-header-infobox-slot">
                  <gz-info-box class="hidden" id="license-disclaimer-info-box-text"></gz-info-box>
                  <gz-compliance-overview id="compliance-overview"></gz-compliance-overview>
                </div>
                <div class="header-buttons hidden" slot="grid-header-actions-slot">
                  <gz-tooltip id="scan-button-tooltip" class="hidden">
                    <gz-button id="scan-button" class="action-button ml-2" type="quiet" color="secondary"></gz-button>
                  </gz-tooltip>
                  <gz-tooltip id="download-report-tooltip">
                    <gz-button id='download-report-button' type="outline" disabled="true"></gz-button>
                  </gz-tooltip>

                </div>
                <div slot="no-results--additional-data" hidden>
                  <gz-text id="riskManagementAdditionalText" fontSize="14"></gz-text>
                  <gz-text id="riskManagementAdditionalSubText" fontSize="14"></gz-text>
                  <gz-button id="complianceLearnMoreButton"></gz-button>
                </div>
              </gz-grid-view>
            </div>
          </div>

          <gz-image-repo state="error" class="loading-error">
            <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
          </gz-image-repo>
        </div>

        <gz-context-menu-overlay id="extra-details-context-menu" class="fit-content"></gz-context-menu-overlay>

        <gz-side-menu
          id="sideMenu"
          menuwidth="530"
          closeOnClickOutside
          resizable="left"
          class="push-body-sidenav resize-content"
        >
        </gz-side-menu>
      </div>
    </div>
  </gz-push-body-layout>
`;
